import { useEffect, useState } from 'react';
import { Redirect } from 'wouter';
import { saveDefaultGameParams } from '../../utils/default-game-params';
import useGameQueryParams from '../../utils/useGameQueryParams.hook';
import ServiceScreen from '../service-screen';

export const GameSetup = () => {
  const [ready, setReady] = useState(false);
  const { gamePlayInfoId, demoId, rp } = useGameQueryParams();
  const gamePlayId = gamePlayInfoId || demoId;

  useEffect(() => {
    if (!gamePlayId) return;

    console.log('>>> setup with game params');
    saveDefaultGameParams();
    setReady(true);
  }, [gamePlayId]);

  if (!gamePlayId) return <p>Missing query string params</p>;

  if (!ready) return <ServiceScreen text="Loading..." />;

  if (rp) return <Redirect to={`/games/${gamePlayId}/${rp}`} />;

  return <Redirect to={`/games/${gamePlayId}`} />;
};
